import { INode, IRenderContext, NodeStyleBase, SvgVisual, TaggedSvgVisual } from "@yfiles/yfiles";
import { createNodeSvg, NodeStyleSettings } from "../../ui-components/svgs/node-svgs";

// the values we use to render the graphics
type Cache = { width: number; height: number, excluded:boolean }

// the type of visual we create and update in CustomNodeStyle
type LinqNodeStyleVisual = TaggedSvgVisual<SVGSVGElement, Cache>

// draws a node as its LINQ icon. yFiles creates a new visual when a node's style changes, so a visual only needs
// redrawing here when the node's size or excluded state changes
export class LinqNodeStyle extends NodeStyleBase<LinqNodeStyleVisual> {

    constructor(public settings:NodeStyleSettings) {
        super()
    }

    // the settings for this node as it is now. Excluded comes from the node, so it is applied to a copy:
    // copies of a style (such as those dragged from the palette) share one settings object
    private settingsFor(node:INode):NodeStyleSettings {
        return Object.assign(new NodeStyleSettings(), this.settings, {excluded: !!node.tag?.excluded})
    }

    protected createVisual(context: IRenderContext, node: INode): LinqNodeStyleVisual {
        const { x, y, width, height } = node.layout
        const settings = this.settingsFor(node)

        const svg:SVGSVGElement =  createNodeSvg(settings, 0, 0, width, height)
        SvgVisual.setTranslate(svg, x, y)

        return SvgVisual.from(svg, { width, height, excluded:settings.excluded })
    }

    override updateVisual(context: IRenderContext, oldVisual: LinqNodeStyleVisual, node: INode): LinqNodeStyleVisual {
        const { x, y, width, height } = node.layout
        // get the cache object we stored in createVisual
        const cache = oldVisual.tag
        const excluded = !!node.tag?.excluded

        if (width !== cache.width || height !== cache.height || excluded !== cache.excluded) {
            // draw again at the new size, or in the excluded colour
            oldVisual.svgElement = createNodeSvg(this.settingsFor(node), 0, 0, width, height)
            oldVisual.tag = { width, height, excluded }
        }

        SvgVisual.setTranslate(oldVisual.svgElement, x, y)
        return oldVisual
    }
}
